import { Empty } from "antd";
import { useNavigate } from "react-router";
import { useGetWishlistQuery } from "../../../../app/features/wishlist/wishlist.api";
import LeftPaginationArrowIcon from "../../../../assets/icons/LeftPaginationArrowIcon";
import RightPaginationArrowIcon from "../../../../assets/icons/RightPaginationArrowIcon";
import CustomPagination from "../../../../components/CustomPagination";
import CourseItem from "../../../../components/ui/CourseItem";
import CourseItemSkeleton from "../../../../components/ui/CourseItemSkeleton";
import useError from "../../../../hooks/useError";
import useFilters from "../../../../hooks/useFilters";

export default function WishlistCourses() {
  const navigate = useNavigate();
  const { limit, page, handlePagination } = useFilters();
  const { data, isLoading, error } = useGetWishlistQuery({});
  useError(error, "কোর্স সমূহ লোড করা যায়নি");

  const wishList = data?.WishlistItem || [];

  return (
    <section>
      <div className="grid xl:grid-cols-3 md:grid-cols-2 gap-6 mb-5">
        {/* {buyingCourse.map((el) => (
          <CourseItem key={el.id} {...el} moreBtnText="কোর্স দেখুন" isWish />
        ))} */}

        {isLoading ? (
          Array.from({ length: 3 }).map((_, index) => (
            <CourseItemSkeleton key={index} />
          ))
        ) : wishList?.length > 0 ? (
          wishList?.map((el) => {
            const course = el?.course;

            return (
              <CourseItem
                key={course?.id}
                img={course?.thumbnailUrl}
                title={course?.title}
                category={course?.category?.name}
                description={course?.description}
                price={course?.price}
                offerPrice={course?.offerPrice || course?.price}
                tags={course?.tags?.map((tag) => ({
                  title: tag?.name,
                  icon: undefined,
                }))}
                id={course?.id}
                onMoreButton={() => navigate(`/courses/${course?.id}`)}
                moreBtnText="কোর্স দেখুন"
                courseUuid={course?.uuid}
              />
            );
          })
        ) : (
          <div className="xl:col-span-3 md:col-span-2 py-5">
            <Empty description="কোর্স সমূহ পাওয়া যায়নি" />
          </div>
        )}
      </div>

      {wishList?.length > 0 && (
        <CustomPagination
          limit={limit}
          page={page}
          total={1}
          handlePagination={handlePagination}
          prevIcon={<LeftPaginationArrowIcon />}
          nextIcon={<RightPaginationArrowIcon />}
          className="border-none"
          paginationClassName="course_pagination pt-4"
          hidePage
        />
      )}
    </section>
  );
}
